
<template>
    <div class="potato_content_box">
        <div class="potato_setting">
            <img class="potato_icon" src="https://p6.moimg.net/mdwxapp/potato_icon.png" />
            <p>小红书种草活动</p>
        </div>
        <div class="potato_column">
            <div class="patato_title">活动时间</div>
            <div class="patato_txt potato_time">{{potatoObj.start_time}} — {{potatoObj.end_time}}</div>
        </div>
        <div class="potato_column">
            <div class="patato_title">活动奖品</div>
            <div class="patato_txt potato_title">{{potatoObj.prize_title}}</div>
            <img class="patato_cover" :src="imgUrlFilter(potatoObj.prize_img, 690 * radio)" />
        </div>
        <div class="potato_column">
            <div class="patato_title">活动参与要求</div>
            <div class="patato_txt patato_describe" ref="describe"></div>
        </div>
        <div class="potato_column">
            <div class="patato_title">奖品发放时间</div>
            <div class="patato_txt distribute_time_type">{{potatoObj.distribute_time}}</div>
        </div>
        <div class="potato_column">
            <el-button type="primary" @click="qrcodeVisible = true">查看种草活动</el-button>
        </div>
    </div>
    <el-dialog v-model="qrcodeVisible" title="查看种草活动" :width="360">
        <div class="qrcode" style="display:flex;align-items:center;flex-direction:column;justify-content: space-between;">
            <img :src="qrcode" style="width:200px;height:200px;" />
            <span style="font-size: 16px;padding:10px 0 0 0;font-weight: 400;color: #7F7F7F;line-height: 16px;">微信扫一扫，查看详情</span>
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button type="primary" @click="qrcodeVisible = false">确定</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import imgUrlFilter from 'md-base-tools/imgUrlFilter'
import cont_match_reg from "@/utils/editor.js"
import { getRednoteInfo } from '@/api/index'
import { domPixelRatio } from 'md-base-tools/env'
import { ElMessageBox } from "element-plus";
export default {
    props: {
        potatoId: {
            type: String
        },
        qrcode: {
            type: String
        },
    },
    watch: {
        "potatoId": {
            handler: function(val) {
                if (val) {
                    this.getPotatoInfo()
                }
            },
            immediate: true,
            deep: true
        }
    },
    data() {
        return {
            radio: parseInt(domPixelRatio()) || 1,
            qrcodeVisible:false,
            qrcodeList: [],
            potatoObj: {}
        }
    },
    methods: {
        getPotatoInfo() {
            getRednoteInfo({
                rednote_draw_id: this.potatoId
            }).then(res => {
                if (res.status == 0) {
                    this.potatoObj = res.data;
                    this.$refs.describe.appendChild(cont_match_reg(res.data.describe ? res.data.describe.replace(/\n/g, "<br>") : ''))
                }else{
                    ElMessageBox.alert(res.message, '提示', {
                        confirmButtonText: '确定'
                    })
                }
            })
        },
        imgUrlFilter() {
            return imgUrlFilter(...arguments)
        },
    }
}
</script>

<style lang="scss" scoped>
.potato_content_box {
    width: 690px;
    margin:0 auto 40px;
    box-sizing:border-box;
    .potato_btn{
        display: none;
    }
    .potato_setting{
        padding: 0 40px;
        width: 100%;
        height: 128px;
        background: #F7F7F7;
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
        justify-content: space-between;
        .potato_icon{
            width: 100px;
            height: auto;
        }
        p{
            font-size: 36px;
            font-weight: 700;
            color: #1A1A1A;
        }
    }
    .potato_column{
        padding: 40px 0 0 0;
        .patato_title{
            color:#1A1A1A;
            font-size: 32px;
            line-height: 32px;
            padding: 0 0 0 40px;
            position: relative;
            &::after{
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                content: '';
                width: 20px;
                height: 20px;
                background: #FF2442;
            }
        }
        .patato_txt{
            padding: 20px 0 0 0;
            font-size: 28px;
            line-height: 42px;
            color: #7F7F7F;
            ::v-deep .html-from-editor {
                p{
                    font-size: 28px;
                    line-height: 42px;
                    color: #7F7F7F;
                    margin: 0 !important;
                }
            }
        }
        .patato_cover{
            margin: 20px auto 0;
            width: 100%;
        }
    }
}
</style>
